import React, { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import SmartRender from "containers/SmartRender";
import { reduxForm } from "redux-form";
import { forms, paths } from "utils/constants";
import { gotoUrl } from "utils/helpers";
import {
  makeSelectGuestOrder,
  makeSelectIncomingInternationalCallsSMSForm,
  makeSelectIncomingInternationalCallsSMSData,
  makeSelectIncomingInternationalCallsSMSFormIsDirty,
  makeSelectIncomingInternationalInitialValues
} from "ducks/selectors";
import { setIncomingInternationalDetails, clearData } from "ducks/actions";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";

const IncomingInternationalCallsSMSHOC = Component =>
  function Comp(props) {
    const { resetData } = props;

    useEffect(() => {
      return () => {
        resetData();
      };
    }, [resetData]);

    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  formValues: makeSelectIncomingInternationalCallsSMSForm(),
  iid: makeSelectIncomingInternationalCallsSMSData(),
  guestOrder: makeSelectGuestOrder(),

  formIsDirty: makeSelectIncomingInternationalCallsSMSFormIsDirty(),
  forminitialValue: makeSelectIncomingInternationalInitialValues()
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  toggleIncomingInternationalCallsSMS: () => {
    const params = {
      order_ref: get(stateProps, "guestOrder.orderRef"),
      settings: [
        {
          setting: "biic",
          value: get(
            stateProps,
            "formValues.allow_incoming_international_calls"
          )
            ? "disable"
            : "enable"
        },
        {
          setting: "biis",
          value: get(stateProps, "formValues.allow_incoming_international_sms")
            ? "disable"
            : "enable"
        }
      ]
    };

    dispatchProps.setIncomingInternationalDetails(params, (_, error) => {
      if (!isEmpty(error)) {
        gotoUrl(paths.MANAGE_ORDER);
      }
    });
  }
});

export const mapDispatchToProps = dispatch => {
  return {
    setIncomingInternationalDetails: (params, callback) =>
      dispatch(setIncomingInternationalDetails(params, callback)),
    resetData: () => dispatch(clearData("setIncomingInternationalDetails"))
  };
};

IncomingInternationalCallsSMSHOC.defaultProps = {};

const withConnect = connect(mapStateToProps, mapDispatchToProps, mergeProps);

export default compose(
  withConnect,
  reduxForm({
    form: forms.INCOMING_INTERNATIONAL_CALLS_SMS_FORM,
    destroyOnUnmount: true
  })
)(IncomingInternationalCallsSMSHOC(SmartRender));
